export const Trend = [
  'Strong Deterioration',
  'Moderate Deterioration',
  'Stable',
  'Moderate Improvement',
  'Strong Improvement',
];

export enum Period {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
}

export const getPeriod = (value: number): Period | null => {
  switch (true) {
    case value <= 20:
      return Period.VERY_LOW;
    case value > 20 && value <= 40:
      return Period.LOW;
    case value > 40 && value <= 60:
      return Period.MODERATE;
    case value > 60 && value <= 80:
      return Period.HIGH;
    case value > 80:
      return Period.VERY_HIGH;
    default:
      return null;
  }
};
